module.exports = __webpack_public_path__ + "videography.svg?fb3e85215e8a5ed7125d348ceba49006";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videography.svg
// module id = 124
// module chunks = 0